export enum BoundaryTypeOption {
    MANUAL = "MANUAL",
    UPLOAD_FILE = "UPLOAD_TYPE",
}
